import toPath from 'lodash/toPath'

/*
  -----------------------
  The follow methods are 100% pulled from `redux-form` v7.4.2
  This is so we can transparently use these methods while we remove redux-form from the project.

  https://github.com/redux-form/redux-form/blob/v7.4.2/src/structure/plain/getIn.js
  https://github.com/redux-form/redux-form/blob/v7.4.2/src/structure/plain/setIn.js

  The types used here are what was used by redux-form
*/

export const getIn = (state: any | Array<any>, field: string): any => {
  if (!state) {
    return state
  }

  const path: string[] = toPath(field)
  const length = path.length
  if (!length) {
    return undefined
  }

  let result: any = state
  for (let i = 0; i < length && result; ++i) {
    result = result[path[i]]
  }

  return result
}

const setInWithPath = (state: any | Array<any>, value: any, path: string[], pathIndex: number): any | Array<any> => {
  if (pathIndex >= path.length) {
    return value
  }

  const first = path[pathIndex]
  const firstState =
    state && (Array.isArray(state) ? state[Number(first)] : state[first])
  const next = setInWithPath(firstState, value, path, pathIndex + 1)

  if (!state) {
// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'number'.
    if (isNaN(first)) {
      return { [first]: next }
    }
    const initialized: Array<any | Array<any>> = []
    initialized[parseInt(first, 10)] = next
    return initialized
  }

  if (Array.isArray(state)) {
// @ts-expect-error - TS2769 - No overload matches this call.
    const copy = [].concat(state)
// @ts-expect-error - TS2322 - Type 'any' is not assignable to type 'never'.
    copy[parseInt(first, 10)] = next
    return copy
  }

  return {
    ...state,
    [first]: next
  }
}

export const setIn = (state: any | Array<any>, field: string, value: any) =>
  setInWithPath(state, value, toPath(field), 0)
